import { Route, Routes } from 'react-router-dom';

import { Layout } from './components/Layout.js';
import { RequireAuth } from './auth/RequireAuth.js';
import { AcceptInvite } from './pages/AcceptInvite.js';
import { AddressBook } from './pages/AddressBook.js';
import { AccountUnlock } from './pages/AccountUnlock.js';
import { Checkout } from './pages/Checkout.js';
import { EmployeeCustomers } from './pages/EmployeeCustomers.js';
import { EmployeeJobs } from './pages/EmployeeJobs.js';
import { EmployeeLogin } from './pages/EmployeeLogin.js';
import { EmployeeLoginConfirm } from './pages/EmployeeLoginConfirm.js';
import { Home } from './pages/Home.js';
import { ImpersonateExchange } from './pages/ImpersonateExchange.js';
import { Login } from './pages/Login.js';
import { LoginCallback } from './pages/LoginCallback.js';
import { PasswordReset } from './pages/PasswordReset.js';
import { PasswordResetConfirm } from './pages/PasswordResetConfirm.js';
import { QuoteAuthorize } from './pages/QuoteAuthorize.js';
import { QuoteEdit } from './pages/QuoteEdit.js';
import { QuoteList } from './pages/QuoteList.js';
import { QuoteNew } from './pages/QuoteNew.js';
import { Register } from './pages/Register.js';
import { TechnologyRequest } from './pages/TechnologyRequest.js';
import { VerifyEmail } from './pages/VerifyEmail.js';

export function App(): JSX.Element {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/password-reset/confirm" element={<PasswordResetConfirm />} />
        <Route path="/account-unlock" element={<AccountUnlock />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        {/* Partner sign-then-pay landing (ADR-009). PUBLIC — authorized by
            the quote-scoped pay token in ?pt=, not a login. */}
        <Route path="/quote/:id/authorize" element={<QuoteAuthorize />} />
        {/* Impersonation surface (ADR-008). Path A: /impersonate.
            Path B: /employee/login → confirm → customer picker. */}
        <Route path="/impersonate" element={<ImpersonateExchange />} />
        <Route path="/employee/login" element={<EmployeeLogin />} />
        <Route path="/employee/login/confirm" element={<EmployeeLoginConfirm />} />
        <Route path="/employee/customers" element={<EmployeeCustomers />} />
        {/* Employee print-jobs overview + reassign (self-guards on the
            employee token, NOT <RequireAuth> which is customer-token auth). */}
        <Route path="/employee/jobs" element={<EmployeeJobs />} />
        <Route
          path="/quotes"
          element={
            <RequireAuth>
              <QuoteList />
            </RequireAuth>
          }
        />
        <Route
          path="/quotes/new"
          element={
            <RequireAuth>
              <QuoteNew />
            </RequireAuth>
          }
        />
        <Route
          path="/quotes/:id"
          element={
            <RequireAuth>
              <QuoteEdit />
            </RequireAuth>
          }
        />
        <Route
          path="/quotes/:id/checkout"
          element={
            <RequireAuth>
              <Checkout />
            </RequireAuth>
          }
        />
        {/* The Technology door's landing. Not under /quotes/* — it mints no
            quote, and putting it there would imply one exists. */}
        <Route
          path="/technology-request"
          element={
            <RequireAuth>
              <TechnologyRequest />
            </RequireAuth>
          }
        />
        {/* Company shared ship-to address book — review + prune saved
            delivery addresses (the default is ERP-owned; removal is guarded). */}
        <Route
          path="/addresses"
          element={
            <RequireAuth>
              <AddressBook />
            </RequireAuth>
          }
        />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}
